import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type AllFaqsSearchQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SearchNode>;
}>;

export type AllFaqsSearchQuery = {
  __typename?: 'Query';
  faqSearch?: Array<{
    __typename?: 'FaqBody';
    id: string;
    title?: string | null;
    sort?: number | null;
    body?: string | null;
    slug: string;
    faqSection: {
      __typename?: 'FaqSection';
      id: string;
      title?: string | null;
      subtitle?: string | null;
      sort?: number | null;
      slug: string;
      faq: { __typename?: 'Faq'; id: string; title?: string | null; sort?: number | null; slug: string };
    };
  }> | null;
};

export type AllFaqsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AllFaqsQuery = {
  __typename?: 'Query';
  allFaqs?: Array<{
    __typename?: 'Faq';
    id: string;
    title?: string | null;
    subtitle?: string | null;
    slug: string;
    target?: Types.FaqTargetEnum | null;
    sort?: number | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  }> | null;
};

export type FaqAreaBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;

export type FaqAreaBySlugQuery = {
  __typename?: 'Query';
  faqBySlug?: {
    __typename?: 'Faq';
    id: string;
    title?: string | null;
    subtitle?: string | null;
    slug: string;
    target?: Types.FaqTargetEnum | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    faqSections?: Array<{
      __typename?: 'FaqSection';
      id: string;
      title?: string | null;
      subtitle?: string | null;
      slug: string;
      sort?: number | null;
      faq: { __typename?: 'Faq'; id: string; slug: string };
    }> | null;
  } | null;
};

export type FaqSectionBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;

export type FaqSectionBySlugQuery = {
  __typename?: 'Query';
  faqSectionBySlug?: {
    __typename?: 'FaqSection';
    id: string;
    title?: string | null;
    subtitle?: string | null;
    slug: string;
    faq: { __typename?: 'Faq'; id: string; title?: string | null; slug: string };
    faqBodies?: Array<{
      __typename?: 'FaqBody';
      id: string;
      title?: string | null;
      body?: string | null;
      sort?: number | null;
      expanded?: boolean | null;
      slug: string;
    }> | null;
  } | null;
};

export type FaqQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type FaqQuery = {
  __typename?: 'Query';
  faq?: {
    __typename?: 'Faq';
    id: string;
    title?: string | null;
    subtitle?: string | null;
    slug: string;
    sort?: number | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    faqSections?: Array<{
      __typename?: 'FaqSection';
      id: string;
      title?: string | null;
      subtitle?: string | null;
      slug: string;
      sort?: number | null;
      faqBodies?: Array<{
        __typename?: 'FaqBody';
        id: string;
        title?: string | null;
        body?: string | null;
        sort?: number | null;
        expanded?: boolean | null;
        slug: string;
      }> | null;
    }> | null;
  } | null;
};

export const AllFaqsSearchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allFaqsSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchNode' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faqSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'body' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faqSection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sort' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'faq' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class AllFaqsSearchGQL extends Apollo.Query<AllFaqsSearchQuery, AllFaqsSearchQueryVariables> {
  document = AllFaqsSearchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const AllFaqsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allFaqs' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allFaqs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '128x128', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class AllFaqsGQL extends Apollo.Query<AllFaqsQuery, AllFaqsQueryVariables> {
  document = AllFaqsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const FaqAreaBySlugDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'faqAreaBySlug' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faqBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '128x128', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faqSections' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'faq' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class FaqAreaBySlugGQL extends Apollo.Query<FaqAreaBySlugQuery, FaqAreaBySlugQueryVariables> {
  document = FaqAreaBySlugDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const FaqSectionBySlugDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'faqSectionBySlug' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faqSectionBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faq' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faqBodies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sort' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'expanded' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class FaqSectionBySlugGQL extends Apollo.Query<FaqSectionBySlugQuery, FaqSectionBySlugQueryVariables> {
  document = FaqSectionBySlugDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const FaqDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'faq' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faq' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '128x128', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faqSections' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'faqBodies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sort' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'expanded' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class FaqGQL extends Apollo.Query<FaqQuery, FaqQueryVariables> {
  document = FaqDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
